<aw-theme context="cms" mode="light">
  <div class="flex h-screen flex-row overflow-hidden">
    <!-- sidebar -->
    <aw-sidebar />

    <!-- Main content -->
    <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
      <div
        class="border-standard-divider flex h-16 shrink-0 items-center justify-end gap-5 overflow-hidden border-b bg-white p-4">
        <aw-button
          [attr.data-testid]="'cms-license-button'"
          [id]="'license-button'"
          [type]="'button'"
          [text]="'Lizenzen'"
          [buttonSize]="'small'"
          (click)="redirectToLicensePage()"
          [style]="'secondary'">
          <span class="material-symbols-rounded pr-2">verified</span>
        </aw-button>
        <aw-button
          [attr.data-testid]="'cms-logout-button'"
          [id]="'logout-button'"
          [type]="'button'"
          [text]="'Logout'"
          (click)="logout()" />
      </div>
        <div class="relative min-h-0 flex-1 p-4 pb-12"
            [class.overflow-hidden]="isFooterPage()"
            [class.overflow-y-auto]="!isFooterPage()">
        @if (configuration()) {
          <div class="m-auto h-full px-12">
            <router-outlet></router-outlet>
          </div>
        }
        <aw-snackbar />
      </div>
    </div>
  </div>
</aw-theme>